import * as React from 'react'

export const CheckIfHeaderFixed = React.createContext(true)

export const CheckIfDesktopContext = React.createContext(false)
